module.exports = __webpack_public_path__ + "img/block1.0fd1a4a4.webp";